import type { CategoryOption } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

export type CriticalElementsExtensions = Record<string, { options: CategoryOption[] }>;

export const criticalElementsExtensions: CriticalElementsExtensions = {
  Demographic: {
    options: [
      {
        value: 'Application Month',
        label: 'Application Month',
        nested: {
          required: true,
          associatedPropertyName: 'options',
          displayName: 'Option',
          multiple: true,
          options: [
            { value: 'Before', label: 'Before' },
            { value: 'September', label: 'September' },
            { value: 'October', label: 'October' },
            { value: 'November', label: 'November' },
            { value: 'December', label: 'December' },
            { value: 'January', label: 'January' },
            { value: 'February', label: 'February' },
            { value: 'March', label: 'March' },
            { value: 'April', label: 'April' },
            { value: 'May', label: 'May' },
            { value: 'June', label: 'June' },
            { value: 'July', label: 'July' },
            { value: 'August', label: 'August' },
          ],
        },
      },
      {
        value: 'Aid Applicant',
        label: 'Aid Applicant',
        nested: {
          required: true,
          associatedPropertyName: 'options',
          displayName: 'Option',
          options: [
            { value: 'Aid Applicant', label: 'Aid Applicant' },
            { value: 'Non-Aid Applicant', label: 'Non-Aid Applicant' },
          ],
        },
      },
      {
        value: 'Direct Admit',
        label: 'Direct Admit',
        nested: {
          required: true,
          associatedPropertyName: 'options',
          displayName: 'Option',
          options: [
            { value: 'Direct Admit', label: 'Direct Admit' },
            { value: 'Non-Direct Admit', label: 'Non-Direct Admit' },
          ],
        },
      },
    ],
  },
  'Academic Program': {
    options: [
      {
        value: 'Academic Index',
        label: 'Academic Index',
        nested: {
          required: true,
          associatedPropertyName: 'options',
          displayName: 'Option',
          options: [
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
          ],
        },
      },
    ],
  },
};
